import React, { useState, useEffect } from 'react';
import * as styledComponents from './styles'
import { Container, Row, Col } from 'react-bootstrap';
import LaunchImage from 'media/launch.png';
import Modal from 'react-modal';
import { useHistory } from "react-router";
import VisibilitySensor from 'react-visibility-sensor';

const URL = 'https://script.google.com/macros/s/AKfycbyVGECAqpGrKySN6nx2J72JEL6fTgoScB3HXQhd2rjBmG3RY41K/exec';

const getModalTitle = (state) => {
  switch (state) {
    case 'sending':
      return 'SENDING';
    case 'success':
      return 'THANK YOU!';
    case 'failure':
    default:
      return 'WE ARE SORRY';
  }
};

const getModalDescription = (state) => {
  switch (state) {
    case 'sending':
      return 'We are sending the request. It may take some seconds...';
    case 'success':
      return 'Here you have your 3-page PDF Report, remember that you can make a free 30 min consultation to define how your product should look like.';
    case 'failure':
    default:
      return 'There is an issue in our system. Please try again later.';
  }
}

const modalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.70)',
    zIndex: '100',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '600px',
    maxWidth: '95%',
    padding: '80px 20px',
    zIndex: '101',
    background: 'linear-gradient(169.29deg, #262B2F -0.68%, #16191D 74.03%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: 'none',
  },
};

const downloadPDF = () => {
  fetch('/report/3_Page_PDF_Tech_Report.pdf')
    .then(resp => resp.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = '3_Page_PDF_Tech_Repor.pdf';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
}

const Benefits = React.forwardRef((props, ref) => {

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalState, setModalState] = useState('sending');
  const history = useHistory();
  const changeVisibility = (isVisible) => {
    if (isVisible) {
      history.push('landing?section=howto&type=scrolled')
    }
  }

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  }
  const handleChangeName = (e) => {
    setName(e.target.value);
  }
  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  }

  const sendRequest = (e) => {
    e.preventDefault();
    toggleModal();
    setModalState('sending');
    var formData = new FormData();
    formData.append('email', email);
    formData.append('name', name);
    fetch(URL, { method: 'POST', body: formData })
      .then((response) => {
        if (response.ok) {
          downloadPDF();
          setModalState('success');
          setEmail('');
          setName('');
          setTimeout(() => {
            setModalIsOpen(false);
          }, 15000);
        } else {
          setModalState('failure');
          setTimeout(() => {
            setModalIsOpen(false);
          }, 5000);
        }
      });
  }

  useEffect(() => {
    Modal.setAppElement('#root');
  }, [])

  return (
    <VisibilitySensor partialVisibility onChange={changeVisibility}>
      <styledComponents.PortfolioContainer ref={ref}>
        <Modal
          style={modalStyle}
          isOpen={modalIsOpen}
          onRequestClose={toggleModal}
        >
          <styledComponents.ModalTitle>{getModalTitle(modalState)}</styledComponents.ModalTitle>
          <styledComponents.ModalContent>{getModalDescription(modalState)}</styledComponents.ModalContent>
          {modalState === 'success' && <styledComponents.CallToAction onClick={() => { window.open("https://calendly.com/luisenriquecgongora") }}>FREE CONSULTATION</styledComponents.CallToAction>}
        </Modal>
        <Container>
          <Row>
            <Col md>
              <styledComponents.ContainerListDesktop>
                <styledComponents.LaunchImageImage src={LaunchImage} />
              </styledComponents.ContainerListDesktop>
            </Col>
            <Col md>
              <styledComponents.Title>
                DO YOU WANT TO LAUNCH YOUR STARTUP BUT YOU DON'T KNOW WHERE TO START? WORK WITH US AND HAVE YOURS READY IN JUST 24 HOURS
            </styledComponents.Title>
              <styledComponents.ContainerListPhone>
                <styledComponents.LaunchImageImage src={LaunchImage} />
              </styledComponents.ContainerListPhone>
              <styledComponents.Description>
                The truth about launching a startup is that it regularly takes founders way more than a month to launch, and the reason for that is that they do not know how to start.<br /><br />
            Leave us your email address and we will send you a Quick PDF Guide which explains all necessary services and technologies which will make your product work.            </styledComponents.Description>
              <styledComponents.InputsContainer onSubmit={sendRequest}>
                <styledComponents.Input placeholder={'Full Name* (or Company Name)'} onChange={handleChangeName} value={name} required />
                <styledComponents.Input placeholder={'Email Address*'} onChange={handleChangeEmail} value={email} required type="email" />
                <styledComponents.CallToAction type="submit">GET PDF GUIDE</styledComponents.CallToAction>
              </styledComponents.InputsContainer>
            </Col>
          </Row>
        </Container>
      </styledComponents.PortfolioContainer>
    </VisibilitySensor>
  );
});

export default Benefits;
